import React from 'react'

export default function Tag({ text, color = '#4268FF' }) {
  return (
    <div className="flex w-fit items-center gap-[6px] rounded-full border border-white/15 bg-white/5 py-[3px] px-[10px]">
      <span
        aria-hidden
        className="h-[6px] w-[6px] rounded-full"
        style={{ backgroundColor: color, boxShadow: `0 0 6px ${color}` }}
      />
      <h4 className="text-[10px] font-semibold uppercase tracking-wide text-white">{text}</h4>
    </div>
  )
}
